module.exports = __webpack_public_path__ + "static/media/20ECE11.500f7987.jpg";